import { useCallback, useState } from 'react'

const KEY = 'lb:collapsed-categories'

function read(): Set<string> {
  try {
    const raw = localStorage.getItem(KEY)
    return new Set(raw ? (JSON.parse(raw) as string[]) : [])
  } catch {
    return new Set()
  }
}

/**
 * Which pantry categories are rolled up. Shared between the docked pantry and
 * the Pantry tab, and kept per device -- it is a viewing preference, not data
 * the other parent should have changed under them.
 */
export function useCollapsedCategories() {
  const [collapsed, setCollapsed] = useState<Set<string>>(read)

  const toggle = useCallback((categoryId: string) => {
    setCollapsed((prev) => {
      const next = new Set(prev)
      if (next.has(categoryId)) next.delete(categoryId)
      else next.add(categoryId)
      try {
        localStorage.setItem(KEY, JSON.stringify([...next]))
      } catch {
        // Private mode: the choice just won't survive a reload.
      }
      return next
    })
  }, [])

  return { collapsed, toggle }
}
